/** App-facing present: binds the scope's config field index to the pure pipeline. */
import type { SearchTableScope } from '@aibees/elephant/store/search-params-store';
import type { SearchBrowseParams } from '@aibees/elephant/types';
import { buildFieldTypeIndex } from './field-index';
import { presentParams } from './pipeline';

export function paramsToReadable(
  scope: SearchTableScope,
  params: Partial<SearchBrowseParams>
): Record<string, unknown> {
  return presentParams(params, buildFieldTypeIndex(scope));
}
